/**
 * Speedbump options for leaving a form with unsaved work. Shared so the dialog
 * reads the same however the user leaves — a drawer's own close button, or a
 * navigation the router blocker caught.
 */
export const DISCARD_CHANGES_PROMPT = {
  title: 'Discard changes?',
  message: 'This form has changes you haven’t saved. Leaving now discards them.',
  confirmLabel: 'Discard changes',
  cancelLabel: 'Keep editing',
  confirmVariant: 'danger',
} as const
